export default __webpack_public_path__ + "images/b9ab1fd1f81bffe3469aff8017a3d95f-christianity.jpg";